<template>
  <div class="field-item">
    <div class="field-label">
      {{ field.label }}<i v-if="field.fill_status" class="impor">*</i>
    </div>
    <div class="field-control">
      <el-checkbox-group :value="value || []" @input="$emit('input', $event)">
        <el-checkbox v-for="(opt, i) in options" :key="i" :label="opt">{{ opt }}</el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldCheckbox',
  props: { field: Object, value: { default: () => [] } },
  computed: { options () { return this.field.data || [] } }
}
</script>
